import React from 'react';

const Vertical = ({ children }) => {
  return (
    <div className="w-screen h-screen bg-secondary">
      {children}
    </div>
  )
}

export default Vertical;